import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import Dashboard from "../views/Dashboard.vue";
import VehicleInventory from "../views/VehicleInventory.vue";
import InventoryRecords from "../views/InventoryRecords.vue";
import jwtDecode from "jwt-decode";
import { Toast } from "vant";

Vue.use(VueRouter);

// 假设你有一个方法用于解码JWT并获取过期时间
function getExpirationTimeFromToken(token) {
  try {
    const decoded = jwtDecode(token);
    const expirationTime = decoded.exp * 1000; // JWT中的exp是秒为单位的Unix时间戳，转换为毫秒
    return expirationTime;
  } catch (error) {
    // 解码失败，可能是无效的token
    console.error("Error decoding token", error);
    return null;
  }
}

/* 在项目开发中，并不是每一个路由跳转都是明确的。 例如很多页面跳转需要登录判断，如果你有登录，则跳转到指定页面，
没有登录则跳转到登录页面。在项目中, 使用路由跳转页面, this.&router.push() 这个方法, 返回Promise对象, 如果不能正常跳转, 
内部会抛出错误, 但是这个错误并不影响程序执行, 如果想解决控制台打印报错信息，通过重写VueRouter原型对象上的push方法, 
覆盖原来抛出异常的方法, "吞掉"异常，切记: 一定要在router创建实例之前 */

/* 在创建router实例对象之前，手动覆盖原型链的push来吞掉报错catch */
// 先存储默认底层的push
const originPush = VueRouter.prototype.push;
// 覆盖原型链的push
VueRouter.prototype.push = function (location, resolve, reject) {
  // this:路由实例对象

  // 判断用户有没有传后面两个可选参数
  if (resolve || reject) {
    return originPush.call(this, location, resolve, reject);
  } else {
    // 用户只传了第一个参数
    /* 
      默认底层： catch()方法代码  throw err : 抛出异常
      吞掉报错原理： 重写catch()方法,把默认底层的 throw err给去掉，就不会抛出异常
      */
    return originPush.call(this, location).catch((err) => {
      //  throw err
    });
  }
};

//路由配置
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      display: "首页",
      homePages: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      display: "登录",
      requiresAuth: false,
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      display: "数据看板",
      requiresAuth: true,
    },
  },
  {
    path: "/vehicle-inventory",
    name: "VehicleInventory",
    component: VehicleInventory,
    meta: {
      display: "车辆盘点",
      requiresAuth: true,
    },
  },
  {
    path: "/inventory-records",
    name: "InventoryRecords",
    component: InventoryRecords,
    meta: {
      display: "盘点记录",
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

/* router.beforeEach((to, from, next) => {  
  // 假设这是从localStorage中获取的token  
  const token = localStorage.getItem("token"); 

  // 检查token是否存在来判断用户是否已登录  
  const isLoggedIn = !!token; // 如果token存在，则认为已登录 
  console.log(from.fullPath)
  console.log(to.fullPath)
  // 假设这是处理登录逻辑的部分  
  if (!isLoggedIn && to.path !== '/login') {  
    console.log(1)

    // 重定向到登录页，并附带原始路径作为 redirect 参数  
    next({  
      path: '/login',  
      query: { redirect: to.fullPath }  
    });  
  } else if (isLoggedIn && to.path === '/login') {  
    console.log(2)
    // 如果用户已登录但尝试访问登录页，重定向到主页  
    next('/home'); // 或者使用 next({ path: '/home' })  
  } else if (isLoggedIn && from.matched.some(record => record.meta.requiresAuth) && to.path !== '/home') {  
    console.log(3)
    // 如果用户从认证页面后退并且不是回到主页，则重定向到主页  
    next('/home'); // 使用 replace 而不是 push  
  } else {  
    console.log(4)
    // 否则，继续导航到目标路由  
    next();  
  }  
}); */

router.beforeEach((to, from, next) => {
  // 从 localStorage 或 sessionStorage 获取 token
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const isLoggedIn = !!token;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (isLoggedIn) {
    if (to.fullPath == "/login") {
      next({
        path: "/",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    if (requiresAuth) {
      next({
        path: "/login",
      });
    } else {
      next();
    }
  }
});

export default router;
